import React from 'react';
import { Container } from 'react-bootstrap';
import Sidebar from './Sidebar';
import './Layout.scss';

function Layout({ children }) {
  return (
    <div className="layout">
      <Sidebar />
      <div className="main-content">
        <Container fluid>
          {children}
        </Container>
      </div>
    </div>
  );
}

export default Layout;